import KeyboardDoubleArrowLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { useNavigate } from "react-router-dom";
import { Autoplay, Navigation, Pagination } from "swiper";
import "swiper/css";
import { Swiper, SwiperSlide } from "swiper/react";
import title from '../../assets/Title.webp';
import titleEN from '../../assets/TitleEN.webp';
import { PartnersList } from "../../pages/Partners/partnersList";
import styles from './Ourpartners.module.css';

export default function OurPartners() {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate()
  const [activeSlide, setActiveSlide] = useState(0);


  const navigatePartners = () => {
    navigate("/partners");
  };
  const handleSlideChange = (swiper) => {
    setActiveSlide(swiper.realIndex);
  };


  return (
    <>
      <div className="mt-2">
        <LazyLoadImage src={i18n.language === "ar" ? title : titleEN} width="100%" alt="title" />
        <Swiper
          dir="rtl"
          spaceBetween={1}
          slidesPerView={5}
          centeredSlides={true}
          autoplay={{
            delay: 1500,
            disableOnInteraction: false,
          }}
          pagination={{
            clickable: true,
          }}
          navigation={false}
          modules={[Autoplay, Pagination, Navigation]}
          className={`${styles.Swiper}`}
          onSlideChange={handleSlideChange}
        >
          {PartnersList.map((image, index) => (
            <SwiperSlide
              key={index}
              className={`${styles.swipperWrapperMobile} ${styles.swipperWrapper} d-flex justify-content-center align-items-center ${activeSlide === index ? styles["active_slide"] : styles['inActive_slide']}`}
            >
              <LazyLoadImage className={styles.pImage} src={require('../../assets/New_Partners/' + image)} alt="icon" />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
      <div className="d-flex justify-content-center mb-2">
        <button
          aria-label="button to be clicked"
          aria-labelledby="button to be clicked"
          className={`btn btn-primary ${styles.btn_all}`}
          onClick={navigatePartners}
        >
          {t("View All")} {i18n.language === "ar" ? <KeyboardDoubleArrowLeftIcon /> : <KeyboardDoubleArrowRightIcon />}
        </button>
      </div>
    </>
  );
}
